module.exports = __webpack_public_path__ + "media/large/real_estate_condos_sale-860fcc7a.jpeg";